<template>
  <v-container fill-height>
    <v-layout justify-center>
      <v-flex>
        <span class="breadcrumbs__title">Cuenta</span>
        <v-icon>mdi-chevron-right</v-icon>
        <span>Perfil</span>
        <v-divider class="mt-2"></v-divider>
        <Snackbar :textError="textError" :isSnackbar="isSnackbar" />
        <v-row class="mt-10">
          <v-col cols="4">
            <v-card class="mx-auto d-flex flex-column justify-center">
              <v-card-title class="justify-center"
                >{{ user.name }} {{ user.surname }}</v-card-title
              >
              <v-img
                v-if="user.picture || pictureToPreview"
                height="122"
                width="165"
                :src="image"
              ></v-img>
              <v-img
                v-else
                height="122"
                width="165"
                src="https://imgur.com/dMIlTsq.png"
              ></v-img>
              <v-divider class="mt-6"></v-divider>
              <v-card-actions class="flex-column">
                <div>
                  <v-btn
                    text
                    class="blue--text"
                    :loading="isSelecting"
                    @click="onButtonUploadClick"
                  >
                    <v-icon left>mdi-cloud-upload</v-icon>
                    SUBIR IMAGEN
                  </v-btn>
                  <input
                    ref="uploader"
                    class="d-none"
                    type="file"
                    accept="image/*"
                    @change="onFileChanged"
                  />
                </div>
                <v-btn class="red--text" text @click="removeImage"
                  ><v-icon left>mdi-close-octagon</v-icon> ELIMINAR IMAGEN
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-col>
          <v-col cols="8">
            <v-card class="mx-auto">
              <v-divider class="mb-6"></v-divider>
              <v-card-text class="text--primary">
                <v-form ref="form" v-model="valid" lazy-validation width="100%">
                  <v-row class="form__row">
                    <v-col cols="12">
                      <v-checkbox
                        class="mt-0"
                        input-value="1"
                        :value="true"
                        v-model="user.status"
                        label="Usuario activo"
                        color="primary"
                        hide-details
                      ></v-checkbox>
                    </v-col>
                    <v-col cols="6">
                      <v-text-field
                        label="Nombre"
                        v-model="user.name"
                        :rules="emptyField"
                        :disabled="!disableNotPtomoter"
                        required
                        outlined
                      ></v-text-field>
                    </v-col>
                    <v-col cols="6">
                      <v-text-field
                        label="Apellido"
                        v-model="user.surname"
                        :rules="emptyField"
                        :disabled="!disableNotPtomoter"
                        required
                        outlined
                      ></v-text-field>
                    </v-col>
                  </v-row>
                  <v-row class="form__row">
                    <v-col cols="6" class="d-flex" v-if="id">
                      <v-text-field
                        label="Email"
                        v-model="user.email"
                        :rules="[...emptyField, ...emailField]"
                        required
                        outlined
                        :disabled="editEmail"
                      ></v-text-field>
                      <v-icon
                        v-if="getUserData && !getUserData.role.includes(10)"
                        @click="editEmail = !editEmail"
                        dark
                        color="primary"
                        class="align-self-baseline edit__fields__icon"
                      >
                        mdi-pencil
                      </v-icon>
                    </v-col>
                    <v-col cols="6" v-else>
                      <v-text-field
                        label="Email"
                        v-model="user.email"
                        :rules="[...emptyField, ...emailField]"
                        required
                        outlined
                      ></v-text-field>
                      <v-icon
                        v-if="id"
                        @click="editEmail = !editEmail"
                        dark
                        color="primary"
                        class="align-self-baseline edit__fields__icon"
                      >
                        mdi-pencil
                      </v-icon>
                    </v-col>
                    <v-col cols="6" v-if="!id">
                      <v-text-field
                        label="Contraseña"
                        type="password"
                        required
                        v-model="user.password"
                        outlined
                        :rules="
                          id
                            ? isDisable
                              ? []
                              : [...emptyField, ...passwordField]
                            : [...emptyField, ...passwordField]
                        "
                      ></v-text-field>
                    </v-col>
                  </v-row>
                  <v-row v-if="id">
                    <v-col
                      cols="12"
                      v-if="getUserData && id === getUserData.id"
                    >
                      <p class="text-caption grey--text mb-0">
                        Para cambiar tu contraseña, haz clic en el icono
                        <v-icon small>mdi-pencil</v-icon>
                        e introduce tu contraseña actual y la nueva contraseña.
                      </p>
                    </v-col>
                    <v-col cols="6" v-if="getUserData && id === getUserData.id"
                      ><v-text-field
                        label="Contraseña actual"
                        type="password"
                        required
                        v-model="user.password"
                        :rules="currentPasswordView ? [] : emptyField"
                      >
                        outlined :disabled="currentPasswordView" ></v-text-field
                      >
                      ></v-col
                    >
                    <v-col cols="6" class="d-flex"
                      ><v-text-field
                        label="Nueva contraseña"
                        type="password"
                        required
                        v-model="newPassword"
                        :rules="
                          id
                            ? editPassword
                              ? []
                              : passwordField
                            : [...emptyField, ...passwordField]
                        "
                        outlined
                        :disabled="editPassword"
                      ></v-text-field
                      ><v-icon
                        v-if="id"
                        @click="editPassword = !editPassword"
                        dark
                        color="primary"
                        class="align-self-baseline edit__fields__icon"
                      >
                        mdi-pencil
                      </v-icon></v-col
                    >
                  </v-row>
                  <v-row class="form__row">
                    <v-col cols="3">
                      <v-autocomplete
                        v-model="siglaUser"
                        :items="siglas"
                        outlined
                        label="Siglas"
                        item-text="sigla"
                        :rules="siglaField"
                        required
                        item-value="sigla"
                        :disabled="!disableNotPtomoter"
                      ></v-autocomplete>
                    </v-col>
                    <v-col cols="5">
                      <v-text-field
                        label="Dirección"
                        v-model="user.address"
                        :rules="emptyField"
                        required
                        readonly
                        outlined
                        :disabled="!disableNotPtomoter"
                      ></v-text-field>
                    </v-col>
                    <v-col cols="4">
                      <v-text-field
                        label="Cargo"
                        v-model="user.post"
                        :rules="emptyField"
                        required
                        outlined
                        :disabled="!disableNotPtomoter"
                      ></v-text-field>
                    </v-col>
                  </v-row>
                </v-form>
              </v-card-text>
              <v-divider class="mb-2"></v-divider>
              <v-card-actions class="pl-4">
                <v-btn
                  class="mb-5 white--text px-8"
                  :disabled="!valid"
                  color="primary"
                  @click="submit"
                  >Guardar</v-btn
                >
              </v-card-actions>
            </v-card>
          </v-col>
        </v-row>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import fieldValidation from "@/utils/fieldValidation.js";
import formatters from "@/utils/formatters.js";
import services from "@/services/services";
import { mapActions, mapGetters } from "vuex";
import Snackbar from "@/components/Snackbar";
import router from "@/router";
export default {
  name: "Profile",
  props: ["id"],
  components: { Snackbar },
  data() {
    return {
      currentEmail: "",
      textError: null,
      isSnackbar: false,
      editEmail: true,
      editPassword: true,
      selectedFile: null,
      isSelecting: false,
      siglas: [
        { id: 1, sigla: "DG", name: "Direcció General" },
        { id: 2, sigla: "DAF", name: "Direcció d'Administració i Finances" },
        { id: 3, sigla: "DPE", name: "Direcció de Projectes Especials" },
        { id: 4, sigla: "DEX", name: "Direcció d'Explotació" },
        { id: 5, sigla: "DCO", name: "Direcció de Comunicació i RSE" },
        {
          id: 6,
          sigla: "DST",
          name: "Direcció de Sistemes Integrats de Gestió i TIC / CCO",
        },
        { id: 7, sigla: "CC", name: "CC" },
      ],
      siglaUser: "",
      user: {
        picture: null,
        name: "",
        surname: "",
        email: "",
        password: "",
        sigla: "",
        address: "",
        post: "",
        creationDate: formatters.formatDate(new Date()),
        status: true,
      },
      userID: null,
      newPassword: "",
      pictureToPreview: null,
      valid: false,
      emptyField: [(v) => fieldValidation.emptyField(v)],
      emailField: [(v) => fieldValidation.validEmail(v)],
      passwordField: [(v) => fieldValidation.passwordField(v)],
      siglaField: [(v) => fieldValidation.dropDownValidation(v)],
    };
  },
  computed: {
    ...mapGetters(["isAuthenticated", "getUserData", "getUsers"]),
    isDisable() {
      return this.id && this.edit;
    },
    image() {
      return this.pictureToPreview || this.user.picture;
    },
    currentPasswordView() {
      if (this.editEmail && this.editPassword) {
        return true;
      } else {
        return false;
      }
    },
    disableNotPtomoter() {
      return this.getUserData && this.getUserData.superAdmin;
    },
  },
  methods: {
    ...mapActions(["addUser", "updateUser", "setActionsLoader"]),
    async submit() {
      if (this.$refs.form.validate()) {
        this.setActionsLoader(true);
        if (this.id) {
          Promise.all(this.uploadFilse(this.id))
            .then((urlsData) => {
              urlsData.forEach((url) => {
                if (url.includes("avatar.")) {
                  this.user.picture = url;
                }
              });
              this.update();
            })
            .catch((error) => {
              console.log(`Some failed: `, error.message);
            });
        } else {
          this.userID = await this.save();
          if (this.userID) {
            Promise.all(this.uploadFilse(this.userID))
              .then((urlsData) => {
                urlsData.forEach((url) => {
                  if (url.includes("avatar.")) {
                    this.user.picture = url;
                  }
                });
                this.update();
              })
              .catch((error) => {
                console.log(`Some failed: `, error.message);
              });
          }
        }
      }
    },
    async save() {
      return this.addUser(this.user);
    },
    async update() {
      if (this.user.superAdmin === undefined) {
        delete this.user.superAdmin;
      }
      if (
        this.id &&
        this.id === this.getUserData.id &&
        this.user.password &&
        (this.newPassword || !this.editEmail)
      ) {
        let reAuth = services.user.reAuthUser(this.user.password);
        if (this.newPassword) {
          reAuth[0]
            .then(() => {
              reAuth[1]
                .updatePassword(this.newPassword)
                .then(() => {
                  this.textError = null;
                  this.isSnackbar = false;
                  this.updateAllUserData();
                })
                .catch((e) => {
                  console.error(e);
                  this.textError =
                    "Algo salió mal. Por favor, vuelva a intentarlo";
                  this.isSnackbar = true;
                });
            })
            .catch((e) => {
              console.error(e);
              this.textError = "Algo salió mal. Por favor, vuelva a intentarlo";
              this.isSnackbar = true;
            });
        } else if (!this.editEmail) {
          reAuth[0]
            .then(() => {
              reAuth[1]
                .updateEmail(this.user.email)
                .then(() => {
                  this.textError = null;
                  this.isSnackbar = false;
                  this.updateAllUserData();
                })
                .catch((e) => {
                  console.error(e);
                  this.textError =
                    "Algo salió mal. Por favor, vuelva a intentarlo";
                  this.isSnackbar = true;
                });
            })
            .catch((e) => {
              console.error(e);
              this.textError = "Algo salió mal. Por favor, vuelva a intentarlo";
              this.isSnackbar = true;
            });
        }
      } else {
        //this.updateAllUserData();
        if (!this.user.id) {
          this.user.id = this.userID;
        }
        this.user.password = this.newPassword;
        services.user
          .updateUser(this.user)
          .then(() => {
            this.setActionsLoader(false);
            this.textError = null;
            this.isSnackbar = true;
            setTimeout(() => {
              //router.push("/users");
              router.go(-1);
            }, 300);
          })
          .catch((error) => {
            this.setActionsLoader(false);
            console.error(error);
            this.textError = "Algo salió mal. Por favor, vuelva a intentarlo";
            this.isSnackbar = true;
          });
      }
    },
    updateAllUserData() {
      services
        .updateData("users", {
          id: this.user.id || this.userID,
          payload: this.user,
        })
        .then(() => {
          this.setActionsLoader(false);
          this.textError = null;
          this.isSnackbar = true;
          setTimeout(() => {
            //router.push("/users");
            router.go(-1);
          }, 300);
        })
        .catch((error) => {
          this.setActionsLoader(false);
          console.error(error);
          this.textError = "Algo salió mal. Por favor, vuelva a intentarlo";
          this.isSnackbar = true;
        });
    },
    onButtonUploadClick() {
      this.isSelecting = true;
      window.addEventListener(
        "focus",
        () => {
          this.isSelecting = false;
        },
        { once: true }
      );

      this.$refs.uploader.click();
    },
    async onFileChanged(e) {
      this.selectedFile = e.target.files[0];
      this.pictureToPreview = URL.createObjectURL(this.selectedFile);
      // do something
    },
    uploadFilse(userId) {
      let filesPromises = [];
      if (this.selectedFile) {
        filesPromises.push(
          services.files.uploadFile(
            "users",
            "avatar." + userId,
            this.selectedFile
          )
        );
      }
      return filesPromises;
    },
    removeImage() {
      // TODO: remove from DB and Firestore
      services.files
        .removeFile("users", this.user.picture)
        .then(() => {
          // File deleted successfully
          this.user.picture = null;
          this.selectedFile = null;
          this.updateAllUserData();
        })
        .catch((e) => {
          console.error(e);
          // Uh-oh, an error occurred!
          this.textError = "Algo salió mal. Por favor, vuelva a intentarlo";
          this.isSnackbar = true;
        });
    },
    checkForUser() {
      return (
        this.id &&
        this.isAuthenticated &&
        this.getUserData &&
        this.id === this.getUserData.id
      );
    },
  },
  watch: {
    getUserData() {
      if (this.checkForUser()) {
        this.currentEmail = this.getUserData.email;
        this.user = this.getUserData;
        this.siglaUser = this.user.sigla;
      } else {
        if (this.id && this.getUsers.length !== 0) {
          this.user = this.getUsers.find((item) => item.id === this.id);
          this.currentEmail = this.user.email;
          this.siglaUser = this.user.sigla;
        }
      }
    },
    id() {
      if (this.checkForUser()) {
        this.currentEmail = this.getUserData.email;
        this.user = this.getUserData;
        this.siglaUser = this.user.sigla;
      } else {
        if (this.id && this.getUsers.length !== 0) {
          this.user = this.getUsers.find((item) => item.id === this.id);
          this.currentEmail = this.user.email;
          this.siglaUser = this.user.sigla;
        }
      }
    },
    siglaUser(sigla) {
      const siglaSelected = this.siglas.find((item) => item.sigla === sigla);
      if (siglaSelected) {
        this.user.sigla = siglaSelected.sigla;
        this.user.address = siglaSelected.name;
      }
    },
  },
  created() {
    //services.sendEmail()
    this.currentEmail = "";
    if (this.checkForUser()) {
      this.currentEmail = this.getUserData.email;
      this.user = this.getUserData;
      this.siglaUser = this.user.sigla;
    } else {
      if (this.id && this.getUsers.length !== 0) {
        this.user = this.getUsers.find((item) => item.id === this.id);
        this.currentEmail = this.user.email;
        this.siglaUser = this.user.sigla;
      }
    }
  },
};
</script>

<style scoped>
.breadcrumbs__title {
  padding: 8px 0;
  border-bottom: 3px solid #008076;
  margin: 0;
  display: inline-block;
}

.theme--light.v-image {
  align-self: center;
  border-radius: 10%;
}

.v-application--is-ltr .v-card__actions > .v-btn.v-btn + .v-btn {
  margin: 0;
}

.separator {
  height: 65px;
}

/* .form__row {
  width: 85%;
} */

.col-6 {
  padding: 0 12px;
}

.edit__fields__icon {
  font-size: 20px;
  margin-left: 5px;
}
</style>
